'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_13vqo_1";
const styles = {
	root: root
};

const FormLabelRequiredText = ({ children = "Required", isDisabled = false }) => {
  return (
    // `aria-hidden` to prevent it from being read redundantly.
    // The associated `input` field should indicate whether it's
    // required to screenreaders.
    React__default.default.createElement("span", { "aria-hidden": "true", className: styles.root, "data-state": isDisabled ? "disabled" : void 0, "data-zds": true }, children)
  );
};

exports.FormLabelRequiredText = FormLabelRequiredText;
//# sourceMappingURL=FormLabelRequiredText.cjs.js.map
